import React from 'react';
import ActivateIQIcon from '../../img/activateiq_icon.png';

const AppLoadingPage = () => (
	<div className="app-loading-page">
		<div className="app-loading-page__content">
			<div className="app-loading-page__brand">
				<img src={ActivateIQIcon} className="app-loading-page__icon" alt="" />
				<span className="app-loading-page__brand-name">Activate IQ</span>
			</div>
			<p>Loading...</p>
		</div>
	</div>
);

export default AppLoadingPage;
